import { useState, useCallback } from 'react';
import APIRequest from '../../../services/APIRequest';

export default function useUserDetail() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUserDetail = useCallback(async (userId) => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await APIRequest.get(`admin/users/${userId}`);
      
      if (response?.ok) {
        const data = response.data?.data;
        if (data) {
          setUser(data);
        } else {
          setError('No user data found');
        }
      } else {
        setError(response?.data?.message || response?.problem || 'Failed to fetch user details');
      }
    } catch (err) {
      console.error('Error fetching user detail:', err);
      setError(err?.message || 'An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    user,
    loading,
    error,
    fetchUserDetail,
  };
}
